import { CANONICAL_SITE_URL } from '@/constants/metadata';

export const ORGANIZATION_ENTITY_ID = `${CANONICAL_SITE_URL}/#organization`;

export const getAuthorUrl = (slug: string): string => `${CANONICAL_SITE_URL}/blog/author/${slug}`;

export const getAuthorEntityId = (slug: string): string => `${getAuthorUrl(slug)}#person`;

export const getBlogPostUrl = (slug: string): string => `${CANONICAL_SITE_URL}/blog/post/${slug}`;

export const getBlogPostEntityId = (slug: string): string => `${getBlogPostUrl(slug)}#article`;
